import React, { useState } from 'react';
import { Chip } from '@mui/material';
import { MenuItem } from '@mui/material';
import { Box, Menu } from '@mui/material';
import { styled } from '@mui/system';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import LockIcon from '@mui/icons-material/Lock';
const ClusterChip = styled(Chip)(({ theme }) => ({
  backgroundColor: '#fff',
  borderRadius: '20px',
  padding: '0 5px',
  '& .MuiChip-label': {
    paddingRight: '5px',
  },
  boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.15)',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
  fontWeight: 500,
}));

const DropdownSelect = ({
  selectedKey,
  options,
  setKey,
  isDisabled,
  freeDataKey,
  handleOnSampleClick,
}: {
  selectedKey: any;
  options: Record<string, string>;
  setKey: React.Dispatch<React.SetStateAction<any>>;
  isDisabled: boolean;
  freeDataKey?: any;
  handleOnSampleClick?: () => void;
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <ClusterChip
        label={options[selectedKey]}
        onClick={handleClick}
        deleteIcon={<KeyboardArrowDownIcon />}
        onDelete={handleClick}
      />
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {Object.entries(options).map(([optionKey, label]) => (
          <MenuItem
            key={optionKey}
            onClick={() => {
              if (isDisabled && optionKey !== freeDataKey) {
                handleOnSampleClick && handleOnSampleClick();
                return;
              }
              setKey(optionKey);
              handleClose();
            }}
            selected={optionKey === selectedKey}
          >
            {label as string} {isDisabled && optionKey !== freeDataKey && <LockIcon />}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default DropdownSelect;
